// Store kiểm soát thông tin thiết lập của người dùng
import ColumnType from "@/commons/wildcards/constants/ColumnType";
import { MSEnum } from '@/commons/enumeration';
import optionAPI from '@/apis/other/optionAPI';
import commonFn from '@/commons/commonFunction';
import listConfigDefault from "@/assets/config/listConfigDefault";

const state = () => ({
  filterAdvance: {
    listAllTask: [],
    listNeedToDo: [],
    listNeedToApprove: [],
    listAssignedByMe: [],
    listInvolve: [],
    listDone: [],
    listDraft: [],
    listApproveUpdateDeadline: []
  },
  // eslint-disable-next-line no-undef
  filterAdvanceDefault: _.cloneDeep(listConfigDefault.filterAdvanceDefault),
});
const getters = {
  filterAdvance(state) {
    return state.filterAdvance
  },
};
const actions = {
  /**
   * goi api lây filter từ database
   * @param {*} context 
   * @param {*} modeTab 
   */
  getFilterAdvanceByTab(context, modeTab) {
    let tabName = commonFn.getTabNameByMode(modeTab);

    let result = context.state.filterAdvance[tabName];

    if (result?.length == 0) {
      optionAPI.getDbOptions('filterAdvance')
        .then((res) => {
          if (res.OptionValue && res.OptionValue[tabName]?.length > 0) {
            // Nếu tồn tại thì set data cho state
            result = res.OptionValue[tabName];
          } else {
            // Nếu chưa có field thì lấy default
            result = context.state.filterAdvanceDefault[tabName];
          }

          context.commit('setFilterAdvanceByTab', { value: result, tabName });
        })
        .catch((err) => {
          // Nếu chưa có key thì lấy default
          result = context.state.filterAdvanceDefault[tabName];
          context.commit('setFilterAdvanceByTab', { value: result, tabName });
        })
    }
  },
  /**
   * Set du lieu filter cho tung tab
   * 
   */
  setFilterAdvanceByTab(context, param) {
    let tabName = commonFn.getTabNameByMode(param.modeTab);

    context.commit('setFilterAdvanceByTab', { value: param.value, tabName });
    context.dispatch('updateFilterAdvanceDb')
  },
  /**
   * goi api luu du lieu filter
   * @param {*} context 
   */
  updateFilterAdvanceDb(context) {
    optionAPI.updateDbOptions(
      {
        "model": {
          "optionKey": "filterAdvance",
          "optionValueType": 3,
          "optionValue": context.getters.filterAdvance
        }
      }
    )
  },
  /**
 * Set du lieu filter cho tung truong trong tab
 * 
 */
  setFieldFilterAdvanceByTab(context, param) {
    let tabName = commonFn.getTabNameByMode(param.modeTab);

    context.commit('setFieldFilterAdvanceByTab', { ...param, tabName })
    context.dispatch('updateFilterAdvanceDb')
  },
  /**
* Set du lieu filter default
* 
*/
  setDefaultFilterAdvanceByTab(context, modeTab) {
    let tabName = commonFn.getTabNameByMode(modeTab);

    context.commit('setFilterAdvanceByTab', { value: context.state.filterAdvanceDefault[tabName], tabName });
    context.dispatch('updateFilterAdvanceDb')
  },
};
const mutations = {
  /**
   * Set toan bo mang filter sau khi lay tu api
   * @param {*} state 
   * @param {*} param 
   */
  setFilterAdvanceByTab(state, param) {
    state.filterAdvance[param.tabName] = param.value;
  },
  /**
   * Set filter khi thay doi tung truong trong app
   * @param {*} state 
   * @param {*} param 
   */
  setFieldFilterAdvanceByTab(state, param) {
    for (let i = 0; i < state.filterAdvance[param.tabName].length; i++) {
      let item = state.filterAdvance[param.tabName][i];
      if (item.dataField == param.dataField) {
        item.value = param.value
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
